export default __webpack_public_path__ + "static/media/er1.abe1e12f.jpg";